import * as Common from '@/agiles/common';
import { paymentAgents } from '../common/flags';

export class TenantLoadQuery extends Common.Query {
    constructor(){
        super('TenantLoadQuery',new Common.ModelBinder(TenantUpdateQuery,false));
    }
}

export class TenantUpdateQuery extends Common.Query {
    constructor(){
        super('TenantUpdateQuery', null); //戻り値はboolean
    }
    public functionFlag: number;
    public adminId: string;
    public adminName: string;
    public telNo: string;
    // 常に案件がONの利用機能
    public get functionFlagOnProjectItem():number {return this.functionFlag | Common.functionFlags.ProjectItem;}
    public set functionFlagOnProjectItem(value:number) {this.functionFlag = value | Common.functionFlags.ProjectItem;}

    public licenseFlag: number;
    public licenseCount: number;
    public approveLicenseCount: number;
    public optionFlag: number;
    public storageSize: number;
    public scannerCount:number;
    public provisioningTemplate:string = null;
    public paidStartDate: Date;
    // プライムプラン用項目
    public get isPrime(): boolean {return (this.licenseFlag & Common.licenseFlags.prime) != 0; }
    public licensePackCount: number;
    public get calcMaxLicenseCount() :number {return this.licensePackCount * 5 + this.licenseCount;}
    public get calcMaxApproveLicenseCount() :number {return this.licensePackCount * 5 + this.approveLicenseCount;}

    //パートナー情報
    public isPartner:boolean;
    public partnerId: string;
    public bankCode: string; 
    public bankName: string; 
    public bankBranchCode: string; 
    public bankBranchName: string; 
    public bankAccountCategory:number = 0;
    public bankAccountCode: string; 
    public bankAccountName : string; 
    public partnerKey: string;     
    public signupURL :string;
    public contractURL : string;
    public corporateNo : string;

    public isContract : boolean;
    
    // 初期費用情報
    public initialAmount :number = 0;
    public applyInitialPriceDiscountCoupon : boolean;

}

export class TenantCancelQuery extends Common.Query {
    constructor(){
        super('TenantCancelQuery', null); //戻り値はboolean
    }
}
export class TenantResetQuery extends Common.Query {
    constructor(generateSampleData:boolean, provisioningTemplate :string, provisioningLicenseFlag:number=null){
        super('TenantResetQuery', null); //戻り値はboolean
        this.generateSampleData = generateSampleData;
        this.provisioningTemplate = provisioningTemplate;
        this.provisioningLicenseFlag = provisioningLicenseFlag;
    }
    public generateSampleData:boolean;
    public provisioningTemplate:string = null;    
    public provisioningLicenseFlag:number = null;
}
export class ReportTemplateResetQuery extends Common.Query {
    constructor(){
        super('ReportTemplateResetQuery', null); //戻り値はboolean
    }
}
export class FileLayoutResetQuery extends Common.Query {
    constructor(){
        super('FileLayoutResetQuery', null); //戻り値はboolean
    }
    public isAsync : boolean = true;
}
export class PaymentInfoLoadQuery extends Common.Query {
    constructor(){
        super('PaymentInfoLoadQuery', new Common.ModelBinder(PaymentInfoUpdateQuery,false)); 
    }
}

export class PaymentInfoUpdateQuery extends Common.Query {
    constructor(){
        super('PaymentInfoUpdateQuery', null); //戻り値はboolean
        this.binders.payJP = new Common.ModelBinder(PaymentInfoPayJP);
    }
    public isPaid : boolean = false;
    public paymentStatus:number;
    public isDefaultAgent:boolean = false;
    public payJP: PaymentInfoPayJP;    
    public trialExpiry: Date;
    public holdPaymentStatus: boolean;
}

export class PaymentInfoPayJP extends Common.ObjectBase {
    constructor(){
        super('PaymentInfoPayJP');
    }    
    public tenantId :string = '';
    public cardId :string = '';
    public brand :string = '';
    public name :string = '';
    public last4 :string = '';
    public exp_month : number=0;
    public exp_year: number=0;
    public token :string = '';
    public cvc_check :string = '';

    public get cardNo():string {
        if (this.last4) return String.format("xxxx-xxxx-xxxx-{0}",this.last4);
        else return "未登録";
    }
    public get expiry():string {
        if (this.last4) return this.exp_month + "/" + this.exp_year;
        else return "";
    }
}
export class UpdatePaymentStatusQuery extends Common.Query {
    constructor(){
        super('UpdatePaymentStatusQuery',null);
    }        
    public paymentAgent:paymentAgents;
}
export class PartnerUpdateQuery extends Common.Query {
    constructor(){
        super('PartnerUpdateQuery', new Common.ModelBinder(Common.TenantUpdateQuery)); //戻り値はboolean
    }    
    public bankCode:string;
    public bankName:string;
    public bankBranchCode:string;
    public bankBranchName:string;
    public bankAccountCategory:number = 0;        
    public bankAccountCode:string;
    public bankAccountName:string;
    public corporateNo:string;
}